<div class="mt-block" :class="$style.rightPanel">
  <div v-if="spinner" :class="$style.pageMargin">
    <animation-processing fill="new-blue" :class="$style.pageSpinner"></animation-processing>
    <span class="mt-serif mt-serif--size3">
      {{$t('pages.contract.spinner.assigned_foundries')}}
    </span>
  </div>
  <v-grid :class="$style.userWrapper" v-else>
    <!-- Foundry Email Verify Banner for grace period expired-->
    <FouEmailVerify
      :showCloseIcon="false"
      :onlyGracePeriodExpired="true"
      labelKey="components.general.verify_email.banner.grace_period_expired_label"
    />
    <div :class="$style.rightSubPanel">
      <section class="ml-25" :class="$style.userPermissionHeader">
        <h1 class="mt-h1" :class="$style.userPermissionContent">{{title}}</h1>
        <div>
          <span :class="$style.userPermissionContent">{{subTitle}}</span>
        </div>
      </section>
      <section class="ml-25 mt-25" :class="$style.userPermissionBottom">
        <slot></slot>
      </section>
    </div>
  </v-grid>
</div>